// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Comments(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Comments" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M18 18L22 22V6C22 5.44772 21.5523 5 21 5H19V14C19 14.55 18.55 15 18 15H6V17C6 17.5523 6.44771 18 7 18H18Z", fill: "currentColor" }),
            React.createElement("path", { d: "M17 3C17 2.44772 16.5523 2 16 2H3C2.44772 2 2 2.44772 2 3V17L6 13H16C16.5523 13 17 12.5523 17 12V3Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Comments.js.map